document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-trial-registration]').forEach((root) => {
    const singleStep = root.dataset.trialSingleStep === 'true';
    const form = root.querySelector('[data-trial-form]');
    const contact = form.querySelector('[data-trial-step="contact"]');
    const schedule = form.querySelector('[data-trial-step="schedule"]');
    const date = form.elements.date;
    const lesson = form.elements.lesson_config_id;
    const submit = form.querySelector('[data-trial-submit]');
    const error = form.querySelector('[data-trial-error]');
    const success = root.querySelector('[data-trial-success]');
    const loading = root.querySelector('[data-trial-loading]');
    const loadingText = root.querySelector('[data-trial-loading-text]');
    const progress = root.querySelector('[data-trial-progress]');
    const initialProgress = progress.textContent;
    const introTitle = root.querySelector('[data-trial-intro-title]');
    const introSubtitle = root.querySelector('[data-trial-intro-subtitle]');
    const introBody = root.querySelector('[data-trial-intro-body]');
    const initialIntro = [introTitle.textContent, introSubtitle.textContent, introBody.textContent];
    const modal = root.closest('.modal');
    const coursesStatus = form.querySelector('[data-trial-courses-status]');
    const coursesRetry = form.querySelector('[data-trial-courses-retry]');
    let coursesRequest = null;
    let step = 'contact';
    let previousResponse = {};
    let pendingRequest = null;
    let trackedSteps = {};

    function trackSuccess(completedStep) {
      if (!modal || !['trialRegistrationModal', 'coachingTrialRegistrationModal', 'informationTrialRegistrationModal'].includes(modal.id) || trackedSteps[completedStep]) return;
      trackedSteps[completedStep] = true;
      // Tracking must never turn a successful registration into a form error.
      try {
        form.dispatchEvent(new CustomEvent('smmart:trial-success', {
          bubbles: true, detail: { step: completedStep }
        }));
      } catch (error) { /* Registration remains successful if tracking is unavailable. */ }
    }

    function validateDate() {
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date());
      const part = type => parts.find(item => item.type === type).value;
      date.min = part('year') + '-' + part('month') + '-' + part('day');
      const weekday = new Date(date.value + 'T12:00:00Z').getUTCDay();
      const valid = date.value && date.value >= date.min && weekday >= 1 && weekday <= 5;
      date.setCustomValidity(date.value && !valid ? 'Choisis une date du lundi au vendredi, à partir d’aujourd’hui.' : '');
      return valid;
    }

    async function updateLessons() {
      if (singleStep) {
        submit.disabled = false;
        return;
      }
      if (coursesRequest) coursesRequest.abort();
      coursesRequest = null;
      lesson.replaceChildren(new Option("Choisis d'abord une date", ''));
      lesson.disabled = true;
      coursesRetry.hidden = true;
      coursesStatus.hidden = true;
      submit.disabled = step === 'schedule';
      if (!validateDate() || step !== 'schedule') return;
      const request = new AbortController();
      coursesRequest = request;
      coursesStatus.textContent = 'Chargement des cours…';
      coursesStatus.hidden = false;
      try {
        const url = new URL(form.dataset.coursesUrl, window.location.origin);
        url.searchParams.set('date', date.value);
        const response = await fetch(url, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          signal: request.signal
        });
        if (!response.ok) throw new Error('Request failed');
        const data = await response.json();
        if (coursesRequest !== request) return;
        lesson.replaceChildren(new Option(data.courses.length ? 'Choisis un cours' : 'Aucun cours disponible', ''));
        data.courses.forEach(course => {
          lesson.appendChild(new Option(course.label, course.lesson_config_id));
        });
        lesson.disabled = !data.courses.length;
        coursesStatus.textContent = data.courses.length ? '' : 'Aucun cours disponible pour cette date.';
        coursesStatus.hidden = !!data.courses.length;
      } catch (exception) {
        if (coursesRequest !== request || exception.name === 'AbortError') return;
        coursesStatus.textContent = 'Impossible de charger les cours. Réessaie dans un instant.';
        coursesStatus.hidden = false;
        coursesRetry.hidden = false;
      } finally {
        if (coursesRequest === request) {
          coursesRequest = null;
          submit.disabled = !!pendingRequest || lesson.disabled;
        }
      }
    }

    function reset() {
      trackedSteps = {};
      if (pendingRequest) pendingRequest.abort();
      pendingRequest = null;
      step = 'contact';
      root.classList.remove('trial-registration--schedule');
      loading.hidden = true;
      progress.textContent = initialProgress;
      [introTitle.textContent, introSubtitle.textContent, introBody.textContent] = initialIntro;
      introBody.hidden = false;
      previousResponse = {};
      form.reset();
      form.hidden = false;
      form.removeAttribute('aria-busy');
      contact.hidden = false;
      contact.disabled = false;
      if (schedule) {
        schedule.hidden = true;
        schedule.disabled = true;
      }
      success.hidden = true;
      error.hidden = true;
      submit.textContent = 'Envoyer';
      updateLessons();
    }

    if (date) date.addEventListener('change', () => {
      updateLessons();
      if (date.value && !validateDate()) date.reportValidity();
    });
    if (date) date.addEventListener('click', () => {
      if (typeof date.showPicker === 'function') {
        try {
          date.showPicker();
        } catch (_) {
          // Keep native date input interaction when the browser blocks the picker.
        }
      }
    });
    if (coursesRetry) coursesRetry.addEventListener('click', updateLessons);
    form.querySelector('[data-trial-cancel]').addEventListener('click', () => {
      if (modal) window.bootstrap.Modal.getOrCreateInstance(modal).hide();
      else {
        reset();
        contact.querySelector('input').focus();
      }
    });
    if (modal) {
      modal.addEventListener('hidden.bs.modal', reset);
      modal.addEventListener('shown.bs.modal', () => contact.querySelector('input').focus());
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (pendingRequest) return;
      if (step === 'schedule' && (!validateDate() || coursesRequest || lesson.disabled)) {
        date.reportValidity();
        return;
      }
      if (!form.reportValidity()) return;
      const request = new AbortController();
      pendingRequest = request;
      const isContact = step === 'contact';
      const payload = isContact ? {
        contact: {
          first_name: form.elements.first_name.value,
          last_name: form.elements.last_name.value,
          email: form.elements.email.value,
          phone_number: form.elements.phone_number.value
        }
      } : {
        registration: {
          date: date.value,
          lesson_config_id: Number(lesson.value),
          origin: form.elements.origin.value,
          comment: form.elements.comment.value,
          previous_response: previousResponse
        }
      };
      if (singleStep) {
        payload.contact.comment = form.elements.comment.value;
        if (form.elements.origin) payload.contact.origin = form.elements.origin.value;
      }
      error.hidden = true;
      submit.disabled = true;
      submit.textContent = 'Envoi en cours…';
      loadingText.textContent = isContact ? 'Enregistrement de tes coordonnées…' : 'Enregistrement de ton créneau…';
      loading.hidden = false;
      form.setAttribute('aria-busy', 'true');
      if (!isContact) schedule.disabled = true;
      try {
        const response = await fetch(isContact ? form.action : form.dataset.enrollUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
          },
          body: JSON.stringify(payload),
          signal: request.signal
        });
        const data = await response.json();
        if (!response.ok) {
          const failure = new Error('Request failed');
          failure.userMessage = data.error;
          throw failure;
        }
        if (pendingRequest !== request) return;
        if (isContact && !singleStep) {
          console.log('Inscription cours d’essai — contact Monday :', data);
          trackSuccess('contact');
          previousResponse = data;
          step = 'schedule';
          root.classList.add('trial-registration--schedule');
          progress.textContent = 'Étape 2 sur 2 · Ton créneau';
          introTitle.textContent = 'Quand veux-tu venir essayer ?';
          introSubtitle.textContent = 'Tes coordonnées sont enregistrées !';
          introBody.textContent = 'Tu n’as plus qu’à choisir le jour, la discipline et l’horaire :)';
          contact.hidden = true;
          contact.disabled = true;
          schedule.hidden = false;
          schedule.disabled = false;
          updateLessons();
          introTitle.closest('h1').focus();
        } else {
          console.log('Inscription cours d’essai — réservation Monday :', data);
          trackSuccess('registration');
          form.hidden = true;
          introTitle.textContent = initialIntro[0];
          introSubtitle.textContent = initialIntro[1];
          introBody.hidden = true;
          success.hidden = false;
          progress.textContent = singleStep ? 'Demande envoyée' : 'Inscription terminée';
          success.focus();
        }
      } catch (exception) {
        if (pendingRequest !== request || exception.name === 'AbortError') return;
        error.textContent = exception.userMessage || "L'envoi a échoué. Réessaie dans un instant.";
        error.hidden = false;
      } finally {
        if (pendingRequest === request) {
          pendingRequest = null;
          loading.hidden = true;
          if (step === 'schedule') schedule.disabled = false;
          form.removeAttribute('aria-busy');
          submit.textContent = step === 'contact' ? 'Envoyer' : "Je m'inscris";
          submit.disabled = step === 'schedule' && lesson.disabled;
        }
      }
    });
  });
});
